import axios from 'axios'
import { API_URL } from '../config'
import { CaptchaManager } from '../managers/captcha'
// import { getUserToken } from 'utils/query-params'

axios.defaults.baseURL = API_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'

// axios.interceptors.request.use(async (config) => {
//   const token = getUserToken()
//
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`
//   }
//
//   return config
// })

/**
 * This is a separate axios instance for requests that require a captcha token
 */
export const captchaAxios = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
})

captchaAxios.interceptors.request.use(async (config) => {
  const captcha = await CaptchaManager.getFreshCaptcha()
  console.debug({ captcha })
  config.headers.Authorization = `Bearer ${captcha}`

  return config
})
